import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';

export interface DialogDocumentsAddMultipleConfirmData {
    groupName: string;
    fileName: string;
    templateName: string;
    documentType: 'file' | 'template';
}

@Component({
    selector: 'dialog-documents-add-multiple-confirm',
    templateUrl: 'dialog-documents-add-multiple-confirm.html',
    styleUrls: ['dialog-documents-add-multiple-confirm.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogDocumentsAddMultipleConfirm extends DialogGeneral {
    constructor(
        public matDialogRef: MatDialogRef<DialogDocumentsAddMultipleConfirm>,
        public dialogRef: MatDialogRef<DialogDocumentsAddMultipleConfirm>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogDocumentsAddMultipleConfirmData
    ) {
        super(matDialogRef);
    }

    ngOnInit(): void {}
}
